import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

export async function fetchExtratos({ token, cnpj, ano }) {
  if (!token || !cnpj || !ano) throw new Error('Token, CNPJ e ano são obrigatórios');
  const response = await axios.get(`${API_BASE_URL.EXTRATO}/search`, {
    params: { idEscola: cnpj, ano },
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}
